<script lang="ts">
	import { siteTitle } from '$lib/stores/nav';

	import { onMount } from 'svelte';

	export let data;

	onMount(() => {
		$siteTitle = 'Datenschutz';
	});
</script>

<div class="mt-4">
	<h1 class="text-4xl mb-10">Datenschutz</h1>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<h2>Verantwortliche</h2>
		<div class="rte">
			<p>
				Diese Informationen gemäß Art. 13 Datenschutz-Grundverordnung (DSGVO) werden von
				nachfolgender Verantwortlichen (im Folgenden: „<i> das Museum </i>“) bereitgestellt:
			</p>
			<p>
				Museen der Stadt Wien,<br />
				Wissenschaftliche Anstalt öffentlichen Rechts<br />
				(FN 623783d, HG Wien)<br />
				Karlsplatz 8<br />
				1040 Wien
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Zwecke und Rechts&shy;grundlagen der Verarbeitung</h2>
		<div class="rte">
			<p>
				Bitte beachten Sie, dass die von Ihnen im Zuge der Erstellung eines Nutzerkontos
				bekannt gegebenen personenbezogenen Daten vom <i> Museum </i>für folgende Zwecke
				aufgrund folgender Rechtsgrundlagen verarbeitet werden:
			</p>
		</div>
	</section>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<h3>Zweck</h3>
		<div class="rte">
			<p>
				Die Daten werden für den Zweck der detaillierten Beschreibung von Fotografien
				verarbeitet. Das Museum stellt Fotografien aus seinem Bestand digital zur Verfügung.
				Diese Fotografien werden online zum Zwecke der detaillierten Beschreibung zur
				Verfügung gestellt. Personen, die sich aktiv am Crowdsourcing beteiligen möchten,
				müssen ein eigenes Nutzerkonto erstellen und sich mit einem frei wählbaren Usernamen
				und Passwort auf der Website des Projekts anmelden. Das Museum informiert die
				Benutzer:innen zudem via angegebener E-Mail-Adresse über Neuigkeiten und begleitende
				Informationen oder Workshops im Rahmen des Projekts.
			</p>
		</div>
	</section>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<h3>Rechtsgrundlage</h3>
		<div class="rte">
			<p>
				Die Rechtmäßigkeit dieser Verarbeitung basiert auf der Erfüllung eines Vertrags zur
				Teilnahme am gegenständlichen Crowdsourcing-Projekt (Art 6 Abs 1 lit b DSGVO) sowie
				auf der Erfüllung einer rechtlichen Verpflichtung des Museums (Art 6 Abs 1 lit c iVm
				§ 4 Abs 2 Wr. MuG) bzw. zur Wahrnehmung einer Aufgabe im öffentlichen Interesse (Art
				6 Abs 1 lit e DSGVO) bzw. aufgrund von berechtigtem Interesse des Museums (Art 6 Abs
				1 lit f DSGVO).
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Übermittlung von personen&shy;bezogenen Daten</h2>
		<div class="rte">
			<p>
				Wenngleich die Crowdsourcingplattform nach ihrem Grundkonzept eine gemeinsame
				Kooperation zwischen dem Museum und der Wienbibliothek im Rathaus ist, erfolgt das
				Teilprojekt „Stadtfotografie“ ohne Involvierung der Wienbibliothek im Rathaus. Eine
				Datenübermittlung an die Wienbibliothek im Rathaus findet nicht statt. Der Webserver
				für den Betrieb der crowdsourcing Plattform wird technisch durch das
				IT-Dienstleistungszentrum der abaton EDV-Dienstleistungs GmbH beim Rechenzentrum
				Raiffeisen Raaba, Hans-Resel-Gasse 17, 8020 Graz als Auftragsverarbeiterin
				betrieben.
			</p>
			<p>
				Beschreibungen werden mit dem jeweiligen (frei wählbaren) Usernamen eines
				Nutzerkontos angezeigt auf der Crowdsourcingplattform angezeigt und sind für
				sämtliche Websitebesucher:innen einsehbar.
			</p>
			<p>
				Eine Übermittlung an Drittländer im Sinne des Art. 44 DSGVO (Staaten, die nicht
				Mitglied in der Europäischen Union oder im Europäischen Wirtschaftsraum sind) findet
				nicht statt.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Hinweis</h2>
		<div class="rte">
			<p>
				Sie sind nicht verpflichtet, ein Nutzerkonto zu erstellen bzw. Ihre
				personenbezogenen Daten bereitzustellen. Beschreibungen der Fotografien können Sie
				aber nur nach Registrierung (mit Nutzerkonto) erstellen. Für die Registrierung ist
				die Bekanntgabe personenbezogener Daten (E-Mail-Adresse, Username und Passwort)
				notwendig.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Speicherdauer</h2>
		<div class="rte">
			<p>
				Wir speichern Ihre Daten nur so lange, wie dies für die Verarbeitungszwecke bzw.
				aufgrund der gesetzlichen Verpflichtungen erforderlich ist (idR sieben Jahre). Mit
				Deaktivierung bzw. Löschung ihres Nutzerkontos werden die zur Registrierung
				erforderlichen personenbezogenen Daten gelöscht. Bitte beachten Sie, dass diese
				Löschung auf bereits erstellte und veröffentlichte Transkriptionen (unter dem
				jeweiligen frei gewählten Usernamen) keinen Einfluss hat.“
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Betroffenen&shy;rechte</h2>
		<div class="rte">
			<p>
				Als betroffene Person haben Sie das Recht auf Auskunft über die Sie betreffenden
				personenbezogenen Daten sowie auf Berichtigung, Löschung oder Einschränkung der
				Verarbeitung, Datenübertragbarkeit oder auf Widerspruch gegen die Verarbeitung.
			</p>
			<p>
				Sie haben das Recht, Ihr Nutzungskonto jederzeit zu deaktivieren. Das hat auf
				bereits erstellte und veröffentlichte Transkriptionen (unter dem jeweiligen frei
				gewählten Usernamen) keinen Einfluss. Wir weisen aber darauf hin, dass dies auf
				bereits erstellte Transkriptionen keinen Einfluss hat.
			</p>
			<p>
				Wenn Sie der Auffassung sind, dass Ihren Rechten nicht oder nicht ausreichend
				nachgekommen wird, haben Sie die Möglichkeit einer Beschwerde bei der <a
					href="https://www.dsb.gv.at/"
					target="_blank"
					rel="noreferrer">Österreichischen Datenschutzbehörde</a
				>:
			</p>
			<p>
				Barichgasse 40-42, 1030 Wien<br />
				E-Mail: <a href="mailto:dsb@dsb.gv.at">dsb@dsb.gv.at</a>
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Datenschutz&shy;beauftragte:r</h2>
		<div class="rte">
			<p>
				Für Fragen zum Datenschutz steht Ihnen das <i>Museum</i> unter
				<a href="mailto:datenschutz@wienmuseum.at">datenschutz@wienmuseum.at</a> zur Verfügung.
			</p>
		</div>
	</section>
</div>
